import { graphql } from "@/gql";

export const relocationPageQuery = graphql(`
  query RelocationPage($slug: String!) {
    relocationPage(slug: $slug) {
      id
      slug
      description
      title
      region
      image {
        ...MediaFields
      }
      points {
        lat
        lng
        radius
        type
      }
    }
  }
`);
